import { doc, getDoc } from "firebase/firestore";
import { resolverLembretes } from "@nhomi/core";
import { db } from "./firebase";
import { fusoDoAparelho, salvarLembretes } from "@/data/users";

/* ============================================================
   O fuso muda, e o lembrete não pode ficar para trás

   O servidor acha quem avisar por `users/{uid}.lembretesUTC`, que é o
   horário local de cada pessoa já convertido para UTC. A conversão só
   pode ser feita aqui: o fuso é do aparelho, e o servidor não tem como
   adivinhá-lo.

   Isso cria um jeito de o lembrete errar a hora em silêncio: quem viaja
   para outro fuso, ou entra no horário de verão, continua com a chave
   calculada pelo deslocamento antigo. Em Portugal, quem pôs almoço ao
   meio-dia passaria a receber às onze — sem nada quebrar e sem nada
   explicar.

   Daí este arquivo. A cada abertura o app compara a ASSINATURA do
   relógio deste aparelho com a da última vez. Igual, não faz nada: nem
   uma leitura. Diferente, relê o perfil e regrava a chave.

   A assinatura leva o fuso E o deslocamento em minutos de propósito. Só
   o nome do fuso não serve: no horário de verão o fuso continua sendo
   `Europe/Lisbon` e é o deslocamento que muda. Só o deslocamento também
   não: dois fusos diferentes coincidem metade do ano.
   ============================================================ */

const CHAVE = "nhomi:lembretes-relogio";

const assinatura = (): string =>
  `${fusoDoAparelho()}|${new Date().getTimezoneOffset()}`;

export async function conferirLembretes(uid: string): Promise<void> {
  if (!uid) return;

  const agora = assinatura();
  let jaConferido = false;
  try {
    jaConferido = localStorage.getItem(CHAVE) === agora;
  } catch {
    /* Armazenamento bloqueado: confere a cada abertura. Uma leitura a
       mais é bem melhor que um lembrete que toca na hora errada para
       sempre — o mesmo critério da presença. */
  }
  if (jaConferido) return;

  try {
    const snap = await getDoc(doc(db, "users", uid));
    const bruto = snap.data()?.["lembretes"];
    // Quem nunca ligou lembrete nenhum não tem o que regravar; marcar o
    // relógio como conferido evita a leitura na próxima abertura.
    if (bruto) await salvarLembretes(uid, resolverLembretes(bruto));
    try { localStorage.setItem(CHAVE, agora); } catch { /* segue */ }
  } catch {
    /* Sem rede ou sem permissão: fica para a próxima abertura, porque a
       assinatura não foi marcada. Falhar aqui não pode aparecer para
       quem está usando o app. */
  }
}
